import styled from '@emotion/styled/macro';
import { Compose } from 'components/common/CommonStyled';

const Element = styled.i`
  display: flex;
  justify-content: center;
  align-items: center;
  color: inherit;

  ${Compose}
`;

function Icon({ iconType, ...rest }) {
  return (
    <Element {...rest} className={`${rest.className || ''} ${iconType}`} />
  );
}

export default Icon;
